export function parseFormData(customerGroup = {}) {
  return {
    legacy_code: customerGroup.legacy_code,
    name: customerGroup.name,
  };
}
